import React, { useState } from "react";
import "./../../../assets/styles/components.css"; // keep your stylesheet

const RequestQuoteModal = ({ isOpen, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("/api/send-quote", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message }),
      });

      if (res.ok) {
        alert("✅ Quote sent successfully!");
        setName("");
        setEmail("");
        setMessage("");
        onClose(); // close modal after success
      } else {
        alert("❌ Failed to send quote. Please contact us via the Contact section.");
      }
    } catch (error) {
      console.error("Error sending quote:", error);
      alert("⚠️ An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Request a Quote</h2>
        <form className="quote-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <textarea
            placeholder="What do you need help with?"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>
          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Submit Request"}
          </button>
          <button type="button" onClick={onClose} className="close-button">
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default RequestQuoteModal;
